<template>
  <div v-if="user">
    <page-header>
      <template #title>
        <h1 class="page-title">Fleet</h1>
      </template>
      <template #actions>
        <page-header-action
          tag="form-button"
          :indicator="downloading"
          @clicked="download"
        >
          Download Export
        </page-header-action>
        <page-header-action tag="router-link" to="/fleet/create">
          Add Vehicle
        </page-header-action>
      </template>
    </page-header>

    <div class="row">
      <div class="col-lg-3">
        <div class="widget widget-primary clickable">
          <div class="widget-label">Total</div>
          <div class="widget-value" v-text="total"></div>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="widget widget-primary clickable">
          <div class="widget-label">Idle</div>
          <div class="widget-value" v-text="idle"></div>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="widget widget-primary">
          <div class="widget-label">Reserved</div>
          <div class="widget-value" v-text="reserved"></div>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="widget widget-primary">
          <div class="widget-label">On Hire</div>
          <div class="widget-value" v-text="on_hire"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <div class="widget widget-primary clickable">
          <div class="widget-label">Awaiting PDI</div>
          <div class="widget-value" v-text="awaiting_pdi"></div>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="widget widget-primary clickable">
          <div class="widget-label">On Hire - Awaiting Collection</div>
          <div class="widget-value" v-text="on_hire_awaiting_collection"></div>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="widget widget-primary">
          <div class="widget-label">Awaiting Repair</div>
          <div class="widget-value" v-text="awaiting_repair"></div>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="widget widget-primary">
          <div class="widget-label">Fleet Utilisation</div>
          <div class="widget-value" v-text="utilisation + '%'"></div>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="card-header">
        <div class="clearfix" style="width: 100%;">
          <div class="row">
            <div class="col-md-4 pb-2">
              <selectlist
                :value="filters.group_id"
                @input="setGroup"
                name="group_id"
                label="Group"
                :options="groups"
                :stacked="true"
                label-name="name"
              ></selectlist>
            </div>
            <div class="col-md-4 pb-2">
              <selectlist
                :value="filters.status_id"
                @input="setStatus"
                name="status_id"
                label="Status"
                :stacked="true"
                :options="statuses"
              ></selectlist>
            </div>
            <div class="col-md-4 pb-2">
              <selectlist
                :value="filters.make_id"
                @input="setMake"
                name="make_id"
                label="Make"
                :stacked="true"
                :options="makes"
              ></selectlist>
            </div>
            <div class="col-md-4 pb-2">
              <selectlist
                :value="filters.transmission_id"
                @input="setTransmission"
                name="transmission_id"
                label="Transmission"
                :stacked="true"
                :options="transmissions"
              ></selectlist>
            </div>
            <div class="col-md-4 pb-2">
              <selectlist
                :value="filters.hire_site_id"
                @input="setHireSite"
                name="hire_site_id"
                label="Hire Site"
                label-name="name"
                :stacked="true"
                :options="hireSites"
              ></selectlist>
            </div>
            <div class="col-md-4 pb-2">
              <label class="control-label">Registration:</label>
              <input
                name="terms"
                type="text"
                class="form-control"
                :value="filters.terms"
                @input="setTerms($event.target.value)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="loading-overlay" v-if="loading"></div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Registration</th>
              <th>Vehicle Group</th>
              <th>Make</th>
              <th>Model</th>
              <th>Transmission</th>
              <th>Hire Site</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:key="index" v-for="(vehicle, index) in vehicles">
              <td v-text="vehicle.registration"></td>
              <td>{{ vehicle.group?.name }}</td>
              <td>{{ vehicle | make }}</td>
              <td v-text="vehicle.model"></td>
              <td>{{ vehicle.transmission?.label || 'Not Selected' }}</td>
              <td>{{ vehicle.hire_site?.name }}</td>
              <td>{{ vehicle.status?.label }}</td>
              <td>
                <router-link
                  class="btn btn-primary"
                  :to="`/fleet/${vehicle.identifier}/edit`"
                >
                  Edit
                </router-link>
                <router-link
                  class="btn btn-warning"
                  :to="`/fleet/${vehicle.identifier}`"
                >
                  View
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer text-right">
        <pagination
          :data="paginator_data"
          v-on:updateResults="getData"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  components: {
    PageHeader,
    PageHeaderAction
  },

  data() {
    return {
      vehicles: [],
      paginator_data: {},
      total: 0,
      idle: 0,
      reserved: 0,
      on_hire: 0,
      awaiting_pdi: 0,
      defleeted: 0,
      on_hire_awaiting_collection: 0,
      awaiting_repair: 0,
      utilisation: 0,
      filters: {
        group_id: '',
        status_id: '',
        make_id: '',
        transmission_id: '',
        hire_site_id: '',
        terms: '',
        not_defleeted: true
      },
      loading: true,
      indicator: false,
      downloading: false
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },

    groups() {
      return this.$store.getters['VehicleGroups/all'].filter(group =>
        group.name.startsWith('B')
      );
    },

    statuses() {
      return this.$store.getters['VehicleStatuses/all'].filter(
        status => status.name !== 'defleeted'
      );
    },

    makes() {
      return this.$store.getters['VehicleMakes/all'];
    },

    transmissions() {
      return this.$store.getters['VehicleTransmissions/all'];
    },

    hireSites() {
      return this.$store.getters['HireSites/all'];
    },
    filteredVehicles() {
      return this.vehicles.filter(
        vehicle => vehicle.status?.name !== 'defleeted'
      );
    }
  },

  mounted() {
    this.$store.commit('VehicleStatuses/retrieve');
    this.$store.commit('HireSites/retrieve');

    this.loadFleet();
    this.loadFleetReport();
  },

  filters: {
    dateFormat(value) {
      if (value) {
        return window.DateManager.format(value);
      }

      return null;
    },

    make(vehicle) {
      if (vehicle.make) {
        return vehicle.make.label;
      }

      return 'Not Provided';
    }
  },

  methods: {
    loadFleet() {
      let identifier = this.user.tenant?.identifier;

      if (identifier) {
        this.getData(`/fleet/${identifier}?per_page=${this.perPage}`);
      }
    },

    loadFleetReport() {
      let identifier = this.user.tenant?.identifier;

      if (identifier) {
        this.loading = true;
        window.Ajax.get(`/fleet/${identifier}/report`)
          .then(response => {
            this.loading = false;
            this.idle = response.data.idle;
            this.reserved = response.data.reserved;
            this.on_hire = response.data.on_hire;
            this.awaiting_pdi = response.data.awaiting_pdi;
            this.defleeted = response.data.defleeted;
            this.on_hire_awaiting_collection =
              response.data.on_hire_awaiting_collection;
            this.awaiting_repair = response.data.awaiting_repair;
            this.utilisation = response.data.utilisation;
          })
          .catch(err => {});
      }
    },

    getData(url) {
      this.loading = true;

      Object.keys(this.filters).forEach(key => {
        url = `${url}&filter[${key}]=${this.filters[key]}`;
      });

      window.Ajax.get(url)
        .then(response => {
          this.loading = false;
          this.vehicles = response.data.data;
          this.paginator_data = response.data;
          this.total = response.data.total;
        })
        .catch(err => {});
    },

    setGroup(group) {
      this.filters.group_id = group;

      this.loadFleet();
    },

    setStatus(status) {
      this.filters.status_id = status;

      this.loadFleet();
    },

    setMake(make) {
      this.filters.make_id = make;

      this.loadFleet();
    },

    setTransmission(transmission) {
      this.filters.transmission_id = transmission;

      this.loadFleet();
    },

    setHireSite(hireSite) {
      this.filters.hire_site_id = hireSite;

      this.loadFleet();
    },

    setTerms: debounce(function(terms) {
      this.filters.terms = terms;

      this.loadFleet();
    }, 400),

    download() {
      this.downloading = true;
      let identifier = this.user.tenant?.identifier;

      if (identifier) {
        let url = `/fleet/${identifier}/download`;

        const queryParams = Object.entries(this.filters)
          .map(([key, value]) => `filter[${key}]=${value}`)
          .join('&');

        url += `?${queryParams}`;

        window.Ajax.download(url)
          .then(() => {
            this.downloading = false;
          })
          .catch(error => {
            this.downloading = false;
            window.toastify.error(
              'Error',
              'There was a problem downloading the export, please try again.'
            );
          });
      }
    }
  },

  watch: {
    user() {
      this.loadFleet();
    }
  }
};
</script>
